import { useState, useLayoutEffect, useRef, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldError, TextArea, Label, TextField } from 'react-aria-components';
import { useSelector, useDispatch } from 'react-redux';
import { selectContent } from '@pages/admin/article/store/selectors';
import { setContent } from '@pages/admin/article/store/slice';
import { Toolbar } from '@pages/admin/article/article-form/content/toolbar/Toolbar';

const minTextAreaHeight = 650;

export const Content = () => {
	const { t } = useTranslation('admin');

	const textareaRef = useRef<HTMLTextAreaElement>(null);
	const content = useSelector(selectContent);
	const dispatch = useDispatch();
	const dispatchSetContent = (content: string) => dispatch(setContent(content));

	const [ textAreaHeight, setTextAreaHeight ] = useState(minTextAreaHeight);

	
	useLayoutEffect(() => {
		if (textareaRef && textareaRef.current) {
			const scrollHeight = textareaRef.current.scrollHeight;
			const newHeight = scrollHeight > minTextAreaHeight ? scrollHeight : minTextAreaHeight;
			setTextAreaHeight(newHeight);
		}
	}, [ content ]);


	const insertNbsp = () => {
		if (!textareaRef || !textareaRef.current) return;
		
		const textarea = textareaRef.current;
		const cursorPosition = textarea.selectionStart;
		const cursorPositionEnd = textarea.selectionEnd;
		const newText = content.slice(0, cursorPosition) + '\u00A0' + content.slice(cursorPositionEnd);
		dispatchSetContent(newText);

		// Set cursor to the position right after the inserted &nbsp;
		setTimeout(() => {
			textarea.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
			textarea.focus();
		}, 0);
	};

	return (
		<div className='form-content'>
			
			<TextField name='content' type='text' isRequired>
				<Label>{t('pages.article.articleForm.content.label')}:</Label>
				<Toolbar insertNbsp={insertNbsp} />
				<TextArea
					ref={textareaRef}
					style={{ height: `${textAreaHeight}px`}}
					value={content}
					onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
						dispatchSetContent(event.target.value);
					}}
				/>
				<FieldError />
			</TextField>

		</div>
	)
}